module.exports = __webpack_public_path__ + "static/media/Check.50eeb28d.svg";